import styled from 'styled-components';

export const Container = styled.div`
  .material-icons-outlined {
    font-size: 17px;
  }

  .progress-card {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    background: #fff;
    padding: 16px;
    margin-bottom: 16px;
  }

  .progress-head {
    display: flex;
    justify-content: space-between;
    color: #21354a;

    strong {
      font-weight: 600;
    }
  }

  .progress-bar-track {
    height: 6px;
    border-radius: 3px;
    background: #e9ecef;
    overflow: hidden;
    margin: 10px 0;

    span {
      height: 100%;
      display: block;
      background: #28a745;
      transition: width 0.3s;
    }
  }

  .progress-summary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 20px;
    font-size: 13px;

    > span {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .text-attention {
      color: #856404;
    }

    .confirm-all {
      margin-left: auto;
      font-size: 13px;
      text-decoration: underline;
    }
  }

  .rules-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .rule-card {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 16px;
    background: #fff;

    &.status-a_validar {
      border-color: #ffc107;
    }

    &.controversial {
      border-color: #dc3545;
    }

    &.status-nao_se_aplica {
      background: #f8f9fa;
    }

    &.rule-add {
      margin-bottom: 16px;
    }

    h3 {
      font-size: 16px;
      font-weight: 600;
      color: #21354a;
      margin: 8px 0;
    }

    blockquote {
      background: #f8f9fa;
      border-left: 3px solid #dee2e6;
      padding: 10px 12px;
      margin: 0 0 10px;
      font-size: 13px;
      font-style: italic;
      color: #495057;
      white-space: pre-wrap;
      word-break: break-word;

      small {
        display: block;
        margin-top: 4px;
        font-size: 13px;
        font-style: normal;
        color: #6c757d;
      }
    }
  }

  .rule-card-head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 10px;
  }

  .rule-meta {
    font-size: 13px;
    color: #6c757d;
  }

  .rule-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    padding: 3px 7px;
    font-size: 12px;
    font-weight: 600;

    .material-icons-outlined {
      font-size: 15px;
    }
  }

  .status-badge-valida {
    background: #d4edda;
    color: #155724;
  }

  .status-badge-a_validar {
    background: #fff3cd;
    color: #856404;
  }

  .status-badge-nao_se_aplica {
    background: #e9ecef;
    color: #6c757d;
  }

  .status-controversa {
    background: #f8d7da;
    color: #721c24;
  }

  .rule-detail {
    margin: 6px 0 10px;
    color: #495057;
  }

  .rule-edital {
    margin: 0 0 10px;
  }

  .open-edital {
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    vertical-align: baseline;

    .material-icons-outlined {
      font-size: 15px;
    }
  }

  .rule-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;

    .btn {
      display: inline-flex;
      align-items: center;
      gap: 6px;
    }

    .btn-outline-secondary {
      color: #21354a;
      border-color: #ced4da;
      background: #fff;
      font-weight: 500;
    }

    .undo-validation {
      font-weight: 600;
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  .proposal-rule-quote {
    border-left: 2px solid #dee2e6;
    padding-left: 10px;
    color: #495057;
    font-style: italic;
    white-space: pre-wrap;
    word-break: break-word;
  }
`;
